import React, {useState, useEffect} from 'react';
import db from '../database'; // Import the PouchDB instance from your db.js file
import { 
    Box,
    Typography,
    Link,
    Card,
    CardContent,
    Badge,
    Stack,
    Button,
    IconButton,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    TextField
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { exportToJsonFile } from '../components/exportdb'
import ImportDialogue from '../components/importDialogue'

const AddTokenDialogue = ({open, setOpen, token, setToken, handleSave}) => {
    return (
        <Dialog open={open} onClose={()=>{setOpen(false)}}>
            <DialogTitle>Edit Value</DialogTitle>
            <DialogContent>
                <DialogContentText>
                Edit the value and save it to local storage.
                </DialogContentText>
                <TextField
                label="Value"
                value={token}
                onChange={(e) => setToken(e.target.value)}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={()=>{setOpen(false)}} color="primary">
                Cancel
                </Button>
                <Button onClick={handleSave} color="primary">
                Save
                </Button>
            </DialogActions>
        </Dialog>
    )
}

const IndMovie = ({item, index, navigateToMovieDetail, navigateToMovieEdit, handleDelete}) => {
    return (
        <Card
        key={index}
        style={{
        margin: '8px',
        minWidth: '200px',
        maxWidth: '300px',
        cursor: 'pointer',
        }}
        >
            <CardContent>
                <Stack direction="row" alignItems="center" justifyContent="space-around">
                    <Typography onClick={navigateToMovieDetail(item._id)} variant="subtitle1" component="div">
                        {item.title}
                    </Typography>
                    <Badge
                        showZero
                        badgeContent={item?.memes?.length ?? 0}
                        color="primary"
                        style={{ marginLeft: 5 }}
                    >
                    </Badge>
                    <IconButton onClick={navigateToMovieEdit(item._id)}>
                        <EditIcon/>                        
                    </IconButton>
                    <IconButton onClick={handleDelete(item._id)}>
                        <DeleteIcon/>                        
                    </IconButton>
                </Stack>
            </CardContent>
        </Card>
    )
}
const Landing = () => {
    const [movies, setMovies] = useState([]);
    const [refreshData, setRefreshData] = useState(false)
    const [showToken, setShowToken] = useState(false);
    const [showImportDialogue, setShowImportDialogue] = useState(false);
    const [token, setToken] = useState('');
    const navigate = useNavigate();
    const navigateToMovieDetail = (id) => {
        return ()=> {
            navigate(`/movie/${id}`)
        }
    }
    const navigateToMovieEdit = (id) => {
        return ()=> {
            navigate(`/movie/${id}/edit`)
        }
    }
    const handleDelete = (id) => {
        return async() => {
            try {
                const doc = await db.get(id);
                if (doc.memes.length >  0) {
                    const memesToDelete = doc.memes.map(meme=>({_id:meme, _deleted: true}))
                    await db.bulkDocs(memesToDelete)
                }
                await db.remove(id, doc._rev)
                setRefreshData(true)
            } catch (e) {
                console.log(`could not delete`, e)
            }
        }
    }
    const getData  = () => {
            db.find({
                selector: {
                    type: 'movie' 
                }
            }).then((result) => {
                console.log(result.docs)
                setMovies(result.docs.sort((a, b) => {
                    if (a.title < b.title) return -1;
                    if (a.title > b.title) return 1;
                    return 0;
                }))
            }).catch((error) => {
                setMovies([])
                console.error('Error querying documents:', error);
            });
    }

    const handleSave = () => {
        // Save the value to local storage
        localStorage.setItem('storedValue', token);
        setShowToken(false);
    };
    useEffect(()=>{
        getData()
        const storedValue = localStorage.getItem('storedValue');
        if (storedValue) {
            setToken(storedValue);
        }
    }, [])
    useEffect(()=>{
        getData()
    }, [refreshData])

    if (movies.length > 0) {
        return (
            <Stack sx={{marginTop:2, paddingTop:2, paddingRight:1, paddingLeft:1}}>
                <Box sx={{display:'flex', justifyContent: 'flex-end'}}>
                    <Button variant="contained" onClick={()=>{exportToJsonFile()}} sx={{mr:2}}>Export DB</Button>
                    <Button variant="contained" onClick={()=>{setShowImportDialogue(true)}} sx={{mr:2}}>Import DB</Button>
                    <Button variant="contained" onClick={()=>{setShowToken(true)}} sx={{mr:2}}>Upadte</Button>
                    <Button onClick={()=>{navigate('/movie/new')}} variant="contained">Add New Movie</Button>
                </Box>
                <Box sx={{display:'flex', flexWrap:'wrap'}}>
                {movies.map((movie, i)=>(<IndMovie key={`movie-${i}`} item={movie} navigateToMovieDetail={navigateToMovieDetail} navigateToMovieEdit={navigateToMovieEdit} index={i} handleDelete={handleDelete}/>))}
            </Box>
                <AddTokenDialogue
                    open={showToken}
                    setOpen={setShowToken}
                    token={token}
                    setToken={setToken}
                    handleSave={handleSave} 
                />
                <ImportDialogue open={showImportDialogue} handleClose={()=>{setShowImportDialogue(false)}}/>
            </Stack>
        )
        
    }
    return (<>
        <Typography>No Movies found</Typography>
        <Link href='/movie/new'>Click Here</Link> to add a movie
        </>)
}


export default Landing
